export default __webpack_public_path__ + "img/cce29601292298e2cb76ae7e96ffbe0b.png";